<template>
  <div class="center-container">
    <v-app>
      <v-navigation-drawer app>
        <!-- Sidebar content -->
      </v-navigation-drawer>

      <v-app-bar app>
        <!-- App Header -->
      </v-app-bar>

      <v-main>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="8" lg="9">
              <!-- Main Column -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4">
              <!-- 1st column in 2 or 3 column layout -->
            </v-col>
            <v-col cols="12" md="4">
              <!-- 2nd column in 2 or 3 column layout -->
            </v-col>
            <v-col cols="12" md="4">
              <!-- 3rd column in 3 column layout -->
            </v-col>
          </v-row>
        </v-container>
      </v-main>

      <v-footer>
        <!-- Trailer -->
      </v-footer>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "PageComponent",
};
</script>

<style scoped>
.center-container {
  margin: 0 auto;
  max-width: 550px;
  min-width: 550px;
  background-color: #ffffff;
}
</style>
